import { NEGOTIATION_TYPES, type NegotiationType } from '@/types/commercial/cart';

export function getNegotiationLabel(type: NegotiationType): string {
  return NEGOTIATION_TYPES.find((n) => n.id === type)?.name ?? type;
}

export function groupCartItemsByType<T extends { negotiationType: NegotiationType }>(
  items: T[],
): Map<NegotiationType, T[]> {
  return items.reduce((acc, item) => {
    const type = item.negotiationType;
    if (!acc.has(type)) acc.set(type, []);
    acc.get(type)?.push(item);
    return acc;
  }, new Map<NegotiationType, T[]>());
}
